<mat-toolbar style="overflow: scroll;">
  <button mat-button routerLink="dashboard" routerLinkActive="active">Dashboard</button>
  <button mat-button routerLink="users" routerLinkActive="active">User accounts</button>
  <button mat-button routerLink="apps" routerLinkActive="active">Apps management</button>
  <button mat-button routerLink="configuration" routerLinkActive="active">Configuration</button>
  <button mat-button routerLink="system-logs" routerLinkActive="active">System logs</button>
</mat-toolbar>
